
export default function Resultat ( props ){
	const negative_result = (
	  <div>
	    <h3 className="large">Désolé</h3>
	    <p className="text">
	      Selon les informations que vous avez saisies, vous ne pouvez pas prétendre à l'Allocation de Rentrée Scolaire
	    </p>
	    <p className="indication">
	      Notez qu'il s'agit d'une simulation qui n'a pas de caractère officiel.
	    </p>
	  </div>
	);

	const positive_result = (
	  <div>
	    <h3 className="large">Bonne nouvelle</h3>
	    <p className="text">
	      Selon les informations que vous avez saisies, vous pouvez prétendre à{' '}
	    </p>
	    <div className="montant">
	      <strong> {props.data.montantARS} €</strong>
	    </div>
	    <p className="allocation">d'Allocation<br />de Rentrée Scolaire.</p>
	    <div className="clear clearfix"></div>
	    <p className="indication">
	      L'ARS sera versée vers le 15 août 2025. Notez qu'il s'agit d'une simulation qui n'a pas de caractère officiel
	    </p>
	  </div>
	);
	return <div class="resultats" >
              <div class="result-container">
                <div class={"img " +  ( props.data.accesARS ?"img-result-positive": "img-result-negative" )} id="img-rslt"></div>
                <div class="result">
                  <div id="simulation" >
                  	{ (props.data.accesARS) ? positive_result:negative_result }

                  </div>
                  <button id="reset" onClick = {props.restart} >Recommencer</button>
                </div>
              </div>
            </div>;
}